import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import WebLicensePurchase from './WebLicensePurchase';

const AccessDenied = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/');
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            background: 'linear-gradient(135deg, var(--navy-deep, #0a1a2a) 0%, var(--navy-light, #162a3d) 100%)',
            color: 'white',
            fontFamily: "'Segoe UI', Roboto, sans-serif",
            padding: '2rem',
            textAlign: 'center'
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                padding: '3rem',
                borderRadius: '20px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                maxWidth: '600px',
                width: '100%',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
                marginBottom: '2rem'
            }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔒</div>
                <h1 style={{
                    margin: '0 0 1rem 0',
                    fontSize: '2rem',
                    background: 'linear-gradient(90deg, #fff 0%, #a5b4fc 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}>
                    Acceso Premium Requerido
                </h1>
                <p style={{
                    color: '#cbd5e1',
                    lineHeight: '1.6',
                    marginBottom: '1rem',
                    fontSize: '1.1rem'
                }}>
                    La versión web de Vortex EXANI-II es exclusiva para usuarios con una suscripción Premium activa.
                </p>
                <p style={{
                    color: '#94a3b8',
                    fontSize: '0.9rem',
                    marginBottom: '2rem'
                }}>
                    Si ya tienes una licencia de la aplicación móvil, asegúrate de que esté activa validándola desde la app.
                </p>

                <div style={{
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'center',
                    flexWrap: 'wrap'
                }}>
                    <button
                        onClick={handleLogout}
                        style={{
                            background: 'transparent',
                            border: '2px solid rgba(255, 255, 255, 0.3)',
                            padding: '10px 24px',
                            color: 'white',
                            borderRadius: '50px',
                            fontSize: '0.9rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.background = 'transparent';
                        }}
                    >
                        Cerrar Sesión
                    </button>
                </div>
            </div>

            {/* Componente de compra de licencia web */}
            <WebLicensePurchase />

            {/* Sección de Preguntas Frecuentes */}
            <div style={{
                background: 'rgba(255, 255, 255, 0.03)',
                borderRadius: '16px',
                padding: '2rem',
                maxWidth: '800px',
                width: '100%',
                marginTop: '2rem',
                textAlign: 'left'
            }}>
                <h3 style={{
                    margin: '0 0 1.5rem 0',
                    fontSize: '1.25rem',
                    color: '#fff',
                    textAlign: 'center'
                }}>
                    ❓ Preguntas Frecuentes
                </h3>

                <div style={{ display: 'grid', gap: '1rem' }}>
                    {[
                        {
                            q: '¿Qué incluye la licencia web?',
                            a: 'Acceso completo a todas las funciones premium de la versión web de Vortex EXANI-II, incluyendo simuladores oficiales, generación de quizzes con IA y materiales de estudio.'
                        },
                        {
                            q: '¿La licencia web funciona en la app móvil?',
                            a: 'No, la licencia web es exclusiva para la versión web y no incluye acceso a la aplicación móvil de Vortex EXANI-II.'
                        },
                        {
                            q: '¿Necesito crear una cuenta?',
                            a: 'Sí, es necesario registrarse para que la licencia se asocie a tu perfil personal y puedas acceder a tu contenido desde cualquier dispositivo.'
                        },
                        {
                            q: '¿Cuánto tiempo tarda en activarse mi licencia?',
                            a: 'Las licencias se activan manualmente en un plazo de 2-4 horas hábiles después de recibir tu comprobante de pago por WhatsApp.'
                        },
                        {
                            q: '¿Puedo cancelar mi suscripción?',
                            a: 'Sí, puedes cancelar tu suscripción en cualquier momento. Tu acceso permanecerá activo hasta el final del período pagado.'
                        },
                        {
                            q: '¿Necesito tener la app móvil para usar la web?',
                            a: 'No, la licencia web es completamente independiente. Puedes usar únicamente la versión web con tu licencia web.'
                        }
                    ].map((faq, index) => (
                        <div key={index} style={{
                            background: 'rgba(255, 255, 255, 0.03)',
                            borderRadius: '12px',
                            padding: '1rem 1.25rem',
                            border: '1px solid rgba(255, 255, 255, 0.05)'
                        }}>
                            <h4 style={{
                                margin: '0 0 0.5rem 0',
                                color: '#a5b4fc',
                                fontSize: '0.95rem',
                                fontWeight: '600'
                            }}>
                                {faq.q}
                            </h4>
                            <p style={{
                                margin: 0,
                                color: '#94a3b8',
                                fontSize: '0.85rem',
                                lineHeight: '1.5'
                            }}>
                                {faq.a}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Información de contacto */}
            <div style={{
                marginTop: '2rem',
                color: '#64748b',
                fontSize: '0.85rem',
                textAlign: 'center'
            }}>
                <p style={{ margin: '0 0 0.5rem 0' }}>
                    ¿Tienes dudas sobre las licencias?
                </p>
                <p style={{ margin: 0 }}>
                    Contáctanos: <a href="mailto:soporte@ascensosapp.com" style={{ color: '#667eea', textDecoration: 'none' }}>soporte@ascensosapp.com</a>
                </p>
            </div>

            <div style={{ marginTop: '2rem', color: '#64748b', fontSize: '0.8rem' }}>
                Vortex EXANI-II &copy; {new Date().getFullYear()}
            </div>
        </div>
    );
};

export default AccessDenied;
